export const locale = import.meta.env.VITE_MEDIA_LOCALE ?? '';
export const fallbackLocale = 'nl';

// TODO: Converse with Nick/Niels about this code (not sure what to do with it)
// -----------------------------------------------------------------------------------
// let locale = !import.meta.env.PRODVUE_APP_MEDIA_LOCALE || fallbackLocale;

// if ('' === '' + locale) {
//     locale = fallbackLocale;
// }
